export default "/kiban/_next/static/images/facebook-d52570a36c40a4a2b735d884a3d7d0f7.png";